import { createContext, useContext, useEffect, useState } from "react";
import { api, setSessionToken } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    localStorage.removeItem("aspire_token");
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, [setUser]);

  const finish = (data) => {
    setSessionToken(data.token);
    setUser(data.user);
    return data.user;
  };
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return data.mfa_required ? data : finish(data);
  };
  const verifyOtp = async (challenge, code, remember) => {
    const { data } = await api.post("/auth/verify-otp", { challenge, code, remember });
    finish(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setSessionToken(null);
    setUser(false);
  };
  return <Ctx.Provider value={{ user, login, verifyOtp, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
